import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import Divider from "../../shared/Divider";
import { registerfields } from "../../../utils/utils";
import FormField from "../utilComponents/FormField";

import Lottie from "lottie-react";
import successAnimation from "../../../lottieJsons/success.json";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormButton from "../../shared/FormButton";
import { useDispatch, useSelector } from "react-redux";
import {
  accountActivation,
  registerAccount,
} from "../../../features/auth/actions/auth";

const RegisterDetailsSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email")
    .max(45)
    .required("This field is required"),
  organization: Yup.string().max(45).required("This field is required"),
  businessType: Yup.string().max(45),
  phone: Yup.string().max(12).required("This field is required"),
  address: Yup.string().required("This field is required"),
  password: Yup.string()
    .min(8, "Password should be atleast 8 characters in length")
    .max(20, "Password should not exceed 20 characters")
    .required("This field is required"),
  confirmPassword: Yup.string()
    .min(8, "Password should be atleast 8 characters in length")
    .max(20, "Password should not exceed 20 characters")
    .required("This field is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

const RegisterDetails = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("key1");
  const email = searchParams.get("key2");

  const [showAnimation, setShowAnimation] = React.useState(true);

  const dispatch = useDispatch();

  const activationLoading = useSelector(
    (state) => state.auth.activationLoading
  );
  const accountActivated = useSelector((state) => state.auth.accountActivated);
  const loading = useSelector((state) => state.auth.loading);

  React.useEffect(() => {
    dispatch(accountActivation(id));
  }, []);

  React.useEffect(() => {
    if (accountActivated === "success") {
      setTimeout(() => {
        setShowAnimation(false);
      }, 3000);
    }
  }, [accountActivated]);

  return (
    <div className="relative">
      {activationLoading ? (
        <div className="text-center">
          Hang tight, we are activating your account!
        </div>
      ) : accountActivated === "success" ? (
        showAnimation ? (
          <div className="flex flex-col justify-center items-center">
            <Lottie
              animationData={successAnimation}
              loop={false}
              style={{ width: "200px", height: "200px" }}
            />
            <p>Account activated successfully!</p>
          </div>
        ) : (
          <>
            <div className="mb-8">
              <div className="font-bold text-lg">Create you account</div>
              <div>
                Please enter the required details to create you account.
              </div>
            </div>
            <Formik
              initialValues={{
                email: email,
                organization: "",
                businessType: "",
                phone: "",
                address: "",
                password: "",
                confirmPassword: "",
              }}
              validationSchema={RegisterDetailsSchema}
              onSubmit={(values) => {
                dispatch(registerAccount({ ...values, vendorUserId: id }));
              }}
            >
              {() => (
                <Form>
                  <div className="flex">
                    <div className="w-1/2 mr-3">
                      {registerfields.slice(0, 4).map((field) => (
                        <FormField key={field.name} {...field} />
                      ))}
                    </div>
                    <div className="w-1/2">
                      {registerfields.slice(4).map((field) => (
                        <FormField key={field.name} {...field} />
                      ))}
                    </div>
                  </div>
                  <div className="flex justify-start mb-2">
                    Have an account? &nbsp;{" "}
                    <Link to="/" className="text-[#3e4095]">
                      Click here
                    </Link>
                  </div>
                  <Divider />
                  <FormButton isSubmitting={loading} buttonText="Register" />
                </Form>
              )}
            </Formik>
          </>
        )
      ) : (
        "Activation failed"
      )}
    </div>
  );
};

export default RegisterDetails;
